import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { defineComponent as _defineComponent } from 'vue';
import useInternalLink from '~/composables/useInternalLinkGraphQL';
import { generateTwicPicBackgroundImageSet } from '~/composables/useResponsiveBackground';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ItemMarketingBannerGraphql',
  props: {
    banner: {
      type: Object,
      required: true
    },
    isPlp: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      $config = _useNuxt2App.$config,
      $trackers = _useNuxt2App.$trackers;
    var backgroundImage = computed(function () {
      var _props$banner, _props$banner$backgro;
      return generateTwicPicBackgroundImageSet($config.public.cloudinaryDomain, (_props$banner = props.banner) === null || _props$banner === void 0 ? void 0 : (_props$banner$backgro = _props$banner.backgroundImage) === null || _props$banner$backgro === void 0 ? void 0 : _props$banner$backgro.url, 567);
    });
    var tagColor = computed(function () {
      var _props$banner2;
      return (_props$banner2 = props.banner) === null || _props$banner2 === void 0 ? void 0 : _props$banner2.tagColor;
    });
    var tagTitle = computed(function () {
      var _props$banner3;
      return (_props$banner3 = props.banner) === null || _props$banner3 === void 0 ? void 0 : _props$banner3.tagTitle;
    });
    var title = computed(function () {
      var _props$banner4;
      return (_props$banner4 = props.banner) === null || _props$banner4 === void 0 ? void 0 : _props$banner4.title;
    });
    var description = computed(function () {
      var _props$banner5;
      return (_props$banner5 = props.banner) === null || _props$banner5 === void 0 ? void 0 : _props$banner5.description;
    });
    var route = useRoute();
    var pageUrl = route.fullPath;
    var plp = computed(function () {
      var _props$isPlp;
      return (_props$isPlp = props === null || props === void 0 ? void 0 : props.isPlp) !== null && _props$isPlp !== void 0 ? _props$isPlp : false;
    });
    var trackingProperties = computed(function () {
      return {
        event_label: 'marketing_card',
        event_name: 'marketing_card',
        menu: !plp.value,
        plp: plp.value,
        title: title.value,
        page_url: pageUrl
      };
    });

    /**
     * Property only existing on Ctnf item-marketing-block that is a wrapper of item-marketing-banner
     * If the property is not present, it means that the banner is not wrapped by a block so the link is crawlable
     **/
    var isLinkCrawlableSeo = computed(function () {
      var _props$banner6, _props$banner7;
      return (_props$banner6 = props.banner) !== null && _props$banner6 !== void 0 && _props$banner6.hasOwnProperty('isLinkCrawlableSeo') ? (_props$banner7 = props.banner) === null || _props$banner7 === void 0 ? void 0 : _props$banner7.isLinkCrawlableSeo : true;
    });
    var link = computed(function () {
      var _props$banner$interna, _props$banner8;
      var linkToReturn = '';
      var internalLinkObj = (_props$banner$interna = (_props$banner8 = props.banner) === null || _props$banner8 === void 0 ? void 0 : _props$banner8.internalLink) !== null && _props$banner$interna !== void 0 ? _props$banner$interna : {};
      var _useInternalLink = useInternalLink(internalLinkObj),
        internalLink = _useInternalLink.internalLink;
      if (internalLinkObj !== null && internalLinkObj !== void 0 && internalLinkObj.publishedInProduction) {
        linkToReturn = internalLink.value;
      } else {
        var _props$banner$externa, _props$banner9;
        linkToReturn = (_props$banner$externa = (_props$banner9 = props.banner) === null || _props$banner9 === void 0 ? void 0 : _props$banner9.externalLink) !== null && _props$banner$externa !== void 0 ? _props$banner$externa : '';
      }
      return linkToReturn;
    });
    return {
      __sfc: true,
      props: props,
      $config: $config,
      $trackers: $trackers,
      backgroundImage: backgroundImage,
      tagColor: tagColor,
      tagTitle: tagTitle,
      title: title,
      description: description,
      route: route,
      pageUrl: pageUrl,
      plp: plp,
      trackingProperties: trackingProperties,
      isLinkCrawlableSeo: isLinkCrawlableSeo,
      link: link,
      NuxtLinkCustom: NuxtLinkCustom,
      AzIcon: AzIcon
    };
  }
});